import styled from "styled-components";

export const PlayerImage = styled.img`
    width: 100px;
    height: 100px;
    border-radius: 50%;
    margin-bottom: 8px;

    &.small{
        width: 50px;
        height: 50px;
    }
`;